import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => {
  const { color, radius, control, fontSize } = theme.tokens;

  return {
    listItem: {
      minHeight: control.icon,
      padding: "10px 12px",
      borderRadius: radius.field,
      textDecoration: "none",
      cursor: "pointer",
      color: color.ink,
      "&:hover": { backgroundColor: color.surface },
      "& .MuiListItemIcon-root": {
        minWidth: 40,
        color: color.ink
      },
      "& .MuiListItemText-primary": {
        fontSize: fontSize.body,
        fontWeight: 600
      },
      "& .MuiChip-root": {
        height: 28,
        fontSize: fontSize.micro
      }
    },
    drawer: {
      "& > div": {
        width: 300,
        maxWidth: "85vw",
        padding: 0,
        // opens from the right (account button sits top-right)
        borderRadius: `${radius.card}px 0 0 ${radius.card}px`
      }
    },
    closeIcon: {
      textDecoration: "none",
      display: "flex",
      justifyContent: "flex-end",
      height: "30px",
      "& > button": {
        width: "30px"
      },
      [theme.media.desktop]: {
        display: "none"
      }
    },
    name: {
      maxWidth: 260,
      padding: "4px 12px 8px",
      fontSize: theme.tokens.fontSize.h3,
      fontWeight: 800
    },
    drawerChild: {
      padding: theme.spacing(2),
      borderRadius: 0
    },
    divider: {
      margin: "8px 12px"
    }
  };
});

export default withCustomStyles;
